import {
  RESULTS_ELI_NONE,
  RESULTS_ELI_SEQUENCE,
  RESULTS_ELI_SEQUENCE_BREAST_FEEDING,
  RESULTS_ELI_SEQUENCE_PREGNANT,
  RESULTS_ELI_SUICIDE,
  RESULTS_ELI_WW
} from "utils/eligibility";

// result for not guided selling assessment
export const FINISHED = "finished";

// results for guided selling assessment
export const PREMIUM_PRODUCT = "Premium";
export const CORE_PRODUCT = "Core";

// results for unified assessment
export const POINTS_WORKSHOP_PROGRAM = "PointsWorkshopProgram";
export const POINTS_PROGRAM = "PointsProgram";
export const DIABETES_WORKSHOP_PROGRAM = "DiabetesWorkshopProgram";
export const DIABETES_PROGRAM = "DiabetesProgram";
export const GLP1_PROGRAM = "GLP1Program";
export const CLINICAL_PROGRAM = "ClinicalProgram";
export const NOT_ELIGIBLE_BULEMIA = "NotEligibleBulemia";
export const NOT_ELIGIBLE_PREGNANCY = "NotEligiblePregnancy";
export const NOT_ELIGIBLE_MENTAL_HEALTH = "NotEligibleMentalHealth";

// Result screen to GTM event mapping
const CLINICAL_ELIGIBLE = "Clinical:eligible";
const CLINICAL_INELIGIBLE = "Clinical:ineligible";

export const resultToEventMap = {
  [RESULTS_ELI_SEQUENCE]: CLINICAL_ELIGIBLE, // Clinical
  [RESULTS_ELI_WW]: CLINICAL_INELIGIBLE, // Clinical
  [RESULTS_ELI_NONE]: CLINICAL_INELIGIBLE, // Clinical
  [RESULTS_ELI_SUICIDE]: CLINICAL_INELIGIBLE, // Clinical
  [RESULTS_ELI_SEQUENCE_PREGNANT]: CLINICAL_INELIGIBLE, // Clinical
  [RESULTS_ELI_SEQUENCE_BREAST_FEEDING]: CLINICAL_INELIGIBLE, // Clinical

  [CLINICAL_PROGRAM]: CLINICAL_ELIGIBLE, // Unified Quiz (All)
  [NOT_ELIGIBLE_PREGNANCY]: CLINICAL_INELIGIBLE, //  Unified Quiz (All)
  [NOT_ELIGIBLE_BULEMIA]: CLINICAL_INELIGIBLE, //  Unified Quiz (All)
  [NOT_ELIGIBLE_MENTAL_HEALTH]: CLINICAL_INELIGIBLE, //  Unified Quiz (All)

  [POINTS_WORKSHOP_PROGRAM]: PREMIUM_PRODUCT, // Unified Quiz V1 & V2
  [POINTS_PROGRAM]: CORE_PRODUCT, // Unified Quiz V1 & V2
  [GLP1_PROGRAM]: CORE_PRODUCT, // Unified Quiz V1 & V2
  [DIABETES_WORKSHOP_PROGRAM]: PREMIUM_PRODUCT, // Unified Quiz V1 & V2
  [DIABETES_PROGRAM]: CORE_PRODUCT, // Unified Quiz V1 & V2

  [PREMIUM_PRODUCT]: PREMIUM_PRODUCT, // Unified Quiz V3 & V4
  [CORE_PRODUCT]: CORE_PRODUCT // Unified Quiz V3 & V4
};
